<template>

  <div class="params-detail">
    <div style="width:98%;margin:25px auto">
      <!-- <el-input class="power" v-model="input" placeholder="帝都塘口" readonly="readonly"></el-input> -->
      <el-select
        v-model="paramerName"
        slot="prepend"
        placeholder=""
        @change="selectParamer"
      >
        <el-option
          v-for="(item,index) in sensors"
          :key="index"
          :label="item.name"
          :value="index"
        ></el-option>

      </el-select>
      <span class="demonstration">时间</span>
      <el-date-picker
        v-model="start"
        :clearable="false"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        :picker-options="pickerTimeOptions"
        placeholder="开始日期"
      >
      </el-date-picker>
      <span class="spr-line"></span>
      <el-date-picker
        v-model="end"
        type="datetime"
        :clearable="false"
        format="yyyy-MM-dd HH:mm"
        :picker-options="pickerTimeOptions"
        placeholder="结束日期"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="search"
      >查询</el-button>
      <!-- <el-button type="success" @click="entry">录入参数</el-button> -->
    </div>
    <div
      ref="electricity"
      id="electricity"
      class="electricity"
      style="height:62vh;width:98%;margin:25px auto"
    ></div>
    <div
      v-if="show"
      class="nodata"
    >
      <img
        src="../../assets/icon_data_empty.png"
        alt=""
      >
      <span>该条件下暂无数据</span>
    </div>
    <dialog-box
      :titleName="titleName"
      :showDialog="showDialog"
      :dialogWidth="dialogWidth"
      @changeShow="changeShow"
    >
      <div class="params-wrap">
        <span class="scope">所在塘口</span>
        <el-select
          v-model="value"
          placeholder="请选择所在塘口"
        >
          <el-option
            label="200mg/l"
            value="1"
          ></el-option>
          <el-option
            label="400mg/l"
            value="2"
          ></el-option>
          <el-option
            label="600mg/l"
            value="3"
          ></el-option>
        </el-select>
      </div>
      <div class="params-wrap">
        <span class="scope">录入日期</span>
        <el-date-picker
          v-model="start"
          type="date"
          placeholder="请选择日期"
        >
        </el-date-picker>
      </div>
      <div class="params-wrap">
        <span class="scope">PH值</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <div class="params-wrap">
        <span class="scope">溶解氧</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <div class="params-wrap">
        <span class="scope">水温</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <div class="params-wrap">
        <span class="scope">氧化电还原</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <div class="params-wrap">
        <span class="scope">亚硝酸盐</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <div class="params-wrap">
        <span class="scope">氨氮</span>
        <el-input
          v-model="input"
          placeholder="请输入PH值"
        ></el-input>
      </div>
      <el-row>
        <el-button>继续录入</el-button>
        <el-button type="primary">保存</el-button>
      </el-row>
    </dialog-box>
  </div>
</template>

<script>
import DialogBox from '../../components/common/DialogBox'
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import index from '../../store/modules/index'
import paramer from '../../store/modules/paramer'
import { mapState, mapActions } from 'vuex'
let date = new Date(new Date(new Date().toLocaleDateString()).getTime())
let endDate = new Date(
  new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
)
export default {
  name: 'WaterParameterDetail',
  components: {
    DialogBox
  },
  data () {
    return {
      show: false,
      showDialog: false,
      titleName: '录入参数 ',
      dialogWidth: '600px',
      input: '',
      paramerName: '',
      start: date,
      end: endDate,
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      typeIndex: this.$route.query.index,
      value: '',
      parameList: [],
      dataList: [],
      iotId: '',
      pond: '',
      seriesName: this.$route.query.name,
      seriesData: [],
      nameList: [],
      xData: [],
      reorganizationData: []
    }
  },
  mounted () {
    if (this.sensors) {
      this.getParameList(this.sensors)
    }
    if (this.equipmentId) {
      this.getIotId(this.equipmentId)
      this.getLineData(this.equipmentId)
      this.search()
    }
  },
  computed: {
    ...mapState(equipmentSocketModule, ['sensors']),
    ...mapState(index, ['equipmentId', 'equipmentList'])
  },
  watch: {
    // $route () {
    //   this.typeIndex = 0
    //   // this.seriesName = this.sensors[0].name
    // },
    sensors (value) {
      this.getParameList(value)
      console.log(this.sensors[0])
      this.typeIndex = 0
      this.seriesName = this.sensors[0].name
      console.log(this.seriesName)
      this.getLineData(this.equipmentId)
    },
    equipmentId (value) {
      this.typeIndex = 0
      this.getIotId(value)
      this.$nextTick(() => {
        this.getLineData(this.equipmentId)
        // this.seriesName = this.sensors[0].name
        // console.log(this.seriesName)
        // this.getLineData(value)
      })
    }
  },
  methods: {
    ...mapActions(paramer, ['getParamerData']),
    // 获取iot设备编号
    getIotId (value) {
      let iid = this.equipmentList.find(f => f.id === value)
      this.iotId = iid.iotId
      this.pond = iid.pond
    },
    // 获取参数名称
    getParameList (value) {
      let a = value.find(f => f.name === this.$route.query.name)
      if (a === undefined && this.sensors.length !== 0) {
        this.paramerName = this.sensors[0].name
      } else if (a === undefined && this.sensors.length === 0) {
        this.paramerName = ''
      } else {
        this.paramerName = a.name
      }
    },

    // 获取曲线数据
    getLineData (value) {
      let obj = {
        id: value,
        rtuId: this.iotId,
        type: this.typeIndex,
        dStart: this.$timeformat(this.start),
        dEnd: this.$timeformat(this.end)
      }
      this.dataList = []
      this.xData = []
      this.seriesData = []
      this.getParamerData(obj)
        .then(data => {
          if (data.length !== 0) {
            this.dataList = data
            this.reorganizationData = this.arrayReorganization(this.dataList)
            this.nameList = this.arrayName(this.dataList)
            this.getXData(this.reorganizationData)
            this.getSeriesData(this.nameList)
            this.tempauure()
            this.show = false
          } else {
            this.dataList = []
            this.xData = []
            this.seriesData = []
            this.tempauure()
            this.show = true
          }
        })
        .catch(err => {
          this.tempauure()
          this.show = true
          console.log(err)
        })
    },
    // 根据名字找时间的点
    findDotByName (namestr) {
      let obj = []
      for (let i = 0; i < this.nameList.length; i++) {
        obj[i] = []
      }
      if (namestr) {
        for (let i = 0; i < this.nameList.length; i++) {
          this.reorganizationData.forEach(element => {
            let findObj = element.item.find(m => {
              if (m.sensorName === '水温') {
                return true
              }
            })
            if (findObj) {
              obj[i].push(findObj.value)
            } else {
              obj[i].push(0)
            }
          })
        }
      } else {
        for (let i = 0; i < this.nameList.length; i++) {
          this.reorganizationData.forEach(element => {
            let findObj = element.item.find(m => {
              if (this.nameList[i].name === m.sensorName) {
                return true
              }
            })
            if (findObj) {
              obj[i].push(findObj.value)
            } else {
              obj[i].push(0)
            }
          })
        }
      }

      return obj
    },
    // 按时间分组
    arrayReorganization (array) {
      let arr = []
      let obj = {}
      let index = 0
      array.forEach(element => {
        if (obj.hasOwnProperty(element.collectTime)) {
          arr[obj[element.collectTime]].item.push(element)
        } else {
          obj[element.collectTime] = index++
          arr.push({
            name: element.collectTime,
            item: [element]
          })
        }
      })
      return arr
    },
    // 按姓名分组
    arrayName (array) {
      let arr = []
      let obj = {}
      let index = 0
      array.forEach(element => {
        if (obj.hasOwnProperty(element.sensorName)) {
          arr[obj[element.sensorName]].item.push(element)
        } else {
          obj[element.sensorName] = index++
          arr.push({
            name: element.sensorName,
            item: [element]
          })
        }
      })
      return arr
    },
    // 获取xdata
    getXData (array) {
      this.xData = []
      array.forEach(element => {
        this.xData.push(this.$timeformat(element.name))
      })
    },
    // seriesData数据
    getSeriesData (array) {
      this.seriesData = []
      console.log(444)
      let len = array.length
      if (array.length > 1) {
        for (let i = 0, size = len; i < size; i++) {
          this.seriesData.push([
            {
              name: '水温',
              yAxisIndex: 0,
              stack: '总量',
              type: 'line',
              symbol: 'none',
              data: this.findDotByName('水温')[i]
            },
            {
              name: this.nameList[i].name,
              yAxisIndex: 1,
              stack: '总量1',
              type: 'line',
              symbol: 'none',
              data: this.findDotByName()[i]
            }
          ])
        }
      } else {
        for (let i = 0, size = len; i < size; i++) {
          this.seriesData.push([
            {
              name: this.nameList[i].name,
              yAxisIndex: 0,
              stack: '总量1',
              type: 'line',
              symbol: 'none',
              data: this.findDotByName()[i]
            }
          ])
        }
      }
      console.log(444)
      console.log(this.seriesData)
    },
    // 切换参数类型
    selectParamer (index) {
      this.$router.replace('/waterParameterDetail')
      this.typeIndex = index
      let obj = {
        id: this.equipmentId,
        rtuId: this.iotId,
        type: this.typeIndex,
        dStart: this.$timeformat(this.start),
        dEnd: this.$timeformat(this.end)
      }

      this.dataList = []
      this.xData = []
      this.seriesData = []
      this.getParamerData(obj)
        .then(data => {
          if (data.length !== 0) {
            this.dataList = data
            this.reorganizationData = this.arrayReorganization(this.dataList)
            this.nameList = this.arrayName(this.dataList)
            this.getXData(this.reorganizationData)
            this.getSeriesData(this.nameList)
            this.tempauure()
            this.show = false
          } else {
            this.dataList = []
            this.xData = []
            this.seriesData = []
            this.tempauure()
            this.show = true
          }
        })
        .catch(err => {
          this.tempauure()
          this.show = true
          console.log(err)
        })
      this.seriesName = this.sensors[index].name
    },
    // 查询
    search () {
      let obj = {
        id: this.equipmentId,
        rtuId: this.iotId,
        type: this.typeIndex,
        dStart: this.$timeformat(this.start),
        dEnd: this.$timeformat(this.end)
      }
      this.dataList = []
      this.xData = []
      this.seriesData = []
      this.getParamerData(obj)
        .then(data => {
          if (data.length !== 0) {
            this.dataList = data
            this.reorganizationData = this.arrayReorganization(this.dataList)
            this.nameList = this.arrayName(this.dataList)
            this.getXData(this.reorganizationData)
            this.getSeriesData(this.nameList)
            this.tempauure()
            this.show = false
          } else {
            this.tempauure()
            this.dataList = []
            this.xData = []
            this.seriesData = []
            this.show = true
          }
        })
        .catch(err => {
          this.tempauure()
          this.show = true
          console.log(err)
        })
    },
    entry () {
      this.showDialog = true
    },
    changeShow () {
      this.showDialog = false
    },
    tempauure (e) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.electricity)

      myChart.clear()

      myChart.setOption({
        backgroundColor: 'rgba(175,201,255,.1)', // 背景色
        title: {
          // 标题
          left: 'center',
          top: 15,
          text: this.pond,
          textStyle: {
            color: '#BBD4E9',
            fontWeight: 'normal'
          }
        },
        grid: {
          // 布局
          top: '12%',
          x: 80,
          y: 45,
          x2: 40,
          y2: 50,
          borderWidth: 1
        },
        tooltip: {
          // 悬浮框
          trigger: 'axis', //  item
          // formatter: '名称：{a} <br/>时间：{b}<br/>数值：{c}',
          textStyle: {
            align: 'left'
          }
        },

        color: ['#0296F4', '#37E08B'],
        xAxis: {
          type: 'category',
          data: this.xData,
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#BBD4E9'
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#07f',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        yAxis:
          this.seriesName === '水温'
            ? [
              {
                name: '水温',
                type: 'value',
                splitLine: {
                  show: false
                },
                axisTick: {
                  // y轴刻度线
                  show: false
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#BBD4E9'
                  }
                },
                // 设置轴线的属性
                axisLine: {
                  lineStyle: {
                    color: '#07f',
                    width: 1 // 这里是为了突出显示加上的
                  }
                }
              }
            ]
            : [
              {
                name: '水温',
                type: 'value',
                splitLine: {
                  show: false
                },
                axisTick: {
                  // y轴刻度线
                  show: false
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#BBD4E9'
                  }
                },
                // 设置轴线的属性
                axisLine: {
                  lineStyle: {
                    color: '#07f',
                    width: 1 // 这里是为了突出显示加上的
                  }
                }
              },
              {
                type: 'value',
                name: this.seriesName,

                splitLine: {
                  show: false
                },
                axisTick: {
                  // y轴刻度线
                  show: false
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#BBD4E9'
                  }
                },
                // 设置轴线的属性
                axisLine: {
                  lineStyle: {
                    color: '#37E08B',
                    width: 1 // 这里是为了突出显示加上的
                  }
                }
              }
            ],
        series: this.seriesData[1] ? this.seriesData[1] : this.seriesData[0]
      })
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    }
  }
}
</script>

<style lang="stylus">
.el-date-picker {
  .el-date-picker__time-header {
    .el-input--small {
      input {
        color: #626262 !important;
        background: #fff !important;
      }
    }
  }

  .el-button--default {
    width: auto !important;
    background: #fff !important;
    // border-color: #409EFF !important;
    color: #409EFF !important;
  }

  .input__inner {
  }

  .el-input--small {
    width: auto !important;
  }
}

.params-detail {
  position: relative;

  .nodata {
    img {
      position: absolute;
      top: 32%;
      left: 44%;
      width: 218px;
      height: 218px;
    }

    span {
      position: absolute;
      top: 70%;
      left: 45.5%;
      color: #6baae6;
      font-size: 20px;
    }
  }

  .el-input {
    width: auto;
    margin-right: 10px;
  }

  .el-input__inner {
    border: 1px solid #07f;
    color: #728ba1;
    background: none;
  }

  .el-button--primary {
    margin-left: 30px;
    padding: 10px 30px !important;
  }

  .demonstration {
    display: inline-block;
    width: 50px;
    margin-left: 10px;
    text-align: center;
    color: #BBD4E9;
  }

  .spr-line {
    display: inline-block;
    width: 12px;
    text-align: center;
    background: #07f;
    height: 1px;
    line-height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

.params-wrap {
  margin-bottom: 10px;

  .scope {
    display: inline-block;
    width: 70px;
    margin-right: 10px;
    text-align: right;
    color: #BBD4E9;
  }

  .el-input__inner {
    border: 1px solid #07f;
    background: none;
  }

  .el-input--suffix .el-input__inner {
    width: 460px;
    color: #BBD4E9;
    background: none;
  }

  .el-input {
    width: 460px;
    background: none;
  }
}

.el-dialog__body {
  .el-row {
    margin-left: 80px;
    margin-top: 40px;

    .el-button--primary {
      color: #fff;
      background-color: #07f;
      margin-right: 15px;
      padding: 10px 30px;
      border-radius: 4px;
      border: 1px solid #07f;
    }

    .el-button--default {
      color: #BBD4E9;
      margin-right: 10px;
      padding: 10px 30px;
      border-radius: 4px;
      border: 1px solid #07f;
      background-color: #203051;
    }
  }
}
</style>
